import formatNumberCommas from 'Utils/formatNumberCommas'

interface Props {
  img: string
  number: number
  title: string
  percentage: number
}

const StatBox: React.FC<Props> = ({ number, percentage, title, img }) => {
  const riseUpIcon = '/media/icons/green-circle-rise-up-icon.svg'
  const downIcon = '/media/icons/red-circle-down-icon.svg'

  const isMorethanOrEqualZero = percentage >= 0

  return (
    <div className='card h-100'>
      <div className='card-body'>
        <div className='row align-items-center'>
          <div className='col-5'>
            <div style={{ width: '85px', height: '85px' }}>
              {/* Image */}
              <img src={img} alt='Stat Box Icon' />
            </div>
          </div>

          <div className='col-7'>
            <div className='d-flex flex-column' style={{ rowGap: '5px' }}>
              {/* Number */}
              <div className='fs-1 fw-bolder'>{formatNumberCommas(number)}</div>

              {/* Title */}
              <div className='fs-7'>{title}</div>

              {/* Percentage */}
              {/* <div className='d-flex flex-row'>
                <img
                  src={isMorethanOrEqualZero ? riseUpIcon : downIcon}
                  alt='Percentage Icon'
                  width={16}
                  height={16}
                />

                <div className='fs-9 ms-2'>{percentage}% (30 days)</div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StatBox
